









import {Component, Prop, Vue} from 'vue-property-decorator';
import { ILocalBadge } from '@/store/modules/badge.store';
@Component
export default class SingleBadge extends Vue {
	@Prop({required: true})
	badge!: ILocalBadge;
}
